import React, { memo } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import StaticBlock from 'common/StaticBlock/StaticBlock';

import SignUpHeader from './SignUpHeader';

const SignUpLayout = ({ children, onClose, signUpPopup, title }) => {
  return (
    <div
      className={cx({
        'signup-popup__container': signUpPopup,
        signup__container: !signUpPopup,
      })}
    >
      <div
        className={cx({
          'signup-popup__col': signUpPopup,
          signup__col: !signUpPopup,
        })}
      >
        <div
          className={cx({
            'signup-popup__wrapper': signUpPopup,
            signup__wrapper: !signUpPopup,
          })}
        >
          <SignUpHeader onClose={onClose} signUpPopup={signUpPopup} title={title} />

          {signUpPopup && (
            <div className="signup-popup__col__banner">
              <StaticBlock options={{ source: 'registration-banner' }} />
            </div>
          )}

          {children}
        </div>
      </div>

      {!signUpPopup && (
        <div className="signup__col__banner">
          <StaticBlock options={{ source: 'registration-banner' }} />
        </div>
      )}
    </div>
  );
};

SignUpLayout.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func,
  signUpPopup: PropTypes.bool,
  title: PropTypes.string,
};

export default memo(SignUpLayout);
